(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('home-reviews-swipe')) {
  customElements.define(
    'home-reviews-swipe',
    class HomeReviewsSwipe extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.userId = this.dataset.userId || '';
        this.track = this.querySelector('.home-reviews__track');
        this.cards = Array.from(this.querySelectorAll('.home-reviews__card'));
        if (!this.cards.length) return;
        this.loadWhenVisible();
      }

      disconnectedCallback() {
        this.reviewsObserver?.disconnect();
        this.reviewsObserver = null;
        this.initialized = false;
      }

      loadWhenVisible() {
        if (this.getBoundingClientRect().top < window.innerHeight + 400) {
          return this.loadReviews();
        }

        if (!('IntersectionObserver' in window)) return this.loadReviews();

        return new Promise((resolve) => {
          this.reviewsObserver = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.reviewsObserver.disconnect();
              this.reviewsObserver = null;
              this.loadReviews().then(resolve);
            },
            { rootMargin: '400px 0px' }
          );
          this.reviewsObserver.observe(this);
        });
      }

      async loadReviews() {
        const groups = {};
        this.cards.forEach((card) => {
          const productId = card.dataset.productId;
          if (!productId) return;
          groups[productId] = groups[productId] || [];
          groups[productId].push(card);
        });

        await Promise.all(
          Object.entries(groups).map(async ([productId, cards]) => {
            const reviews = await this.fetchReviews(productId);
            const used = new Set();
            cards.forEach((card) => {
              const review = reviews.find((item) => item.reviewId && !used.has(item.reviewId));
              if (review) used.add(review.reviewId);
              this.hydrateCard(card, review);
            });
          })
        );
      }

      async fetchReviews(productId) {
        if (!this.userId || !productId) return [];
        const mediaUrl = `https://api.okendo.io/v1/stores/${this.userId}/products/shopify-${productId}/reviews?limit=25&orderBy=has_media%20desc`;

        try {
          const mediaRes = await fetch(mediaUrl);
          const mediaData = mediaRes.ok ? await mediaRes.json() : {};
          const reviews = (Array.isArray(mediaData.reviews) ? mediaData.reviews : []).filter(
            (item) =>
              item.reviewId &&
              Number(item.rating) === 5 &&
              Array.isArray(item.media) &&
              item.media.length &&
              (item.body || '').trim().length > 40
          );

          return reviews.sort((a, b) => this.reviewScore(b) - this.reviewScore(a));
        } catch (error) {
          return [];
        }
      }

      hydrateCard(card, review) {
        const title = card.querySelector('.home-reviews__title');
        const body = card.querySelector('.home-reviews__body');
        const author = card.querySelector('.home-reviews__author');
        const verified = card.querySelector('.home-reviews__verified');
        const date = card.querySelector('.home-reviews__date');
        const photo = card.querySelector('.home-reviews__photo-img');
        const stars = card.querySelectorAll('.home-reviews__star');
        const starsEl = card.querySelector('.home-reviews__stars');
        const productTitle = card.dataset.productTitle || '';
        const productImage = card.dataset.productImage || '';

        if (!review) {
          if (title) title.textContent = productTitle;
          if (starsEl) starsEl.hidden = true;
          card.classList.add('is-ready');
          return;
        }

        const media = Array.isArray(review.media)
          ? review.media.find((item) => item.type === 'image') || review.media[0]
          : null;
        const photoUrl = media?.largePortraitThumbnailUrl || media?.largeUrl || media?.fullSizeUrl || productImage;
        const reviewer = review.reviewer || {};
        const rating = Math.max(0, Math.min(5, Number(review.rating) || 0));

        if (title) title.textContent = review.title || productTitle;
        if (body) body.textContent = review.body || '';
        if (author) author.textContent = reviewer.displayName || '';
        if (date && review.dateCreated) date.textContent = this.formatTimeAgo(review.dateCreated);
        if (verified && reviewer.isVerified) verified.classList.add('is-visible');
        if (photo && photoUrl) {
          photo.srcset = '';
          photo.src = photoUrl;
          photo.alt = media?.alt || reviewer.displayName || productTitle;
        }

        stars.forEach((star, index) => {
          star.classList.toggle('is-empty', index >= rating);
        });
        if (starsEl) {
          starsEl.hidden = false;
          starsEl.setAttribute('aria-label', `${rating} out of 5 stars`);
        }
        card.classList.add('is-ready');
      }

      reviewScore(review) {
        const body = (review.body || '').trim();
        const title = (review.title || '').trim();
        const created = new Date(review.dateCreated);
        let score = 0;

        if (body.length >= 80 && body.length <= 240) score += 60;
        else score -= Math.abs(body.length - 160) / 6;

        if (title.length > 0 && title.length <= 48) score += 12;
        if (review.reviewer?.isVerified) score += 20;
        if (!Number.isNaN(created.getTime()) && Date.now() - created.getTime() < 365 * 86400000) {
          score += 15;
        }

        return score;
      }

      formatTimeAgo(iso) {
        const then = new Date(iso);
        if (Number.isNaN(then.getTime())) return '';
        const now = new Date();
        const days = Math.round((now - then) / 86400000);
        if (days < 1) return 'today';
        if (days === 1) return '1 day ago';
        if (days < 30) return `${days} days ago`;
        const months = Math.round(days / 30.44);
        if (months === 1) return '1 month ago';
        if (months < 12) return `${months} months ago`;
        const years = Math.round(days / 365.25);
        return years === 1 ? '1 year ago' : `${years} years ago`;
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-curly-ingredients"] && !Shopify.designMode) return;
  try {
    
(function () {
  function cardsIn(track, cloned) {
    var selector = '[data-curly-ingredients-card]' + (cloned ? '[data-clone]' : ':not([data-clone])');
    return Array.prototype.slice.call(track.querySelectorAll(selector));
  }

  function allCards(track) {
    return Array.prototype.slice.call(track.querySelectorAll('[data-curly-ingredients-card]'));
  }

  function perView(viewport, track) {
    var card = track.querySelector('[data-curly-ingredients-card]');
    if (!card) return 1;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    var cardWidth = card.getBoundingClientRect().width;
    if (!cardWidth) return 1;
    return Math.max(1, Math.round((viewport.clientWidth + gap) / (cardWidth + gap)));
  }

  function cardLeft(viewport, card) {
    return card.getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft;
  }

  function nearestIndex(viewport, cards) {
    var viewLeft = viewport.getBoundingClientRect().left;
    var best = 0;
    var bestDistance = Infinity;
    cards.forEach(function (card, index) {
      var distance = Math.abs(card.getBoundingClientRect().left - viewLeft);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = index;
      }
    });
    return best;
  }

  function jumpTo(viewport, left) {
    viewport.dataset.curlyIngredientsLock = String(Number(viewport.dataset.curlyIngredientsLock || 0) + 1);
    viewport.style.scrollSnapType = 'none';
    viewport.style.scrollBehavior = 'auto';
    viewport.scrollLeft = left;
    viewport.style.scrollBehavior = '';
    viewport.style.scrollSnapType = '';
  }

  function recenter(viewport, track) {
    var reals = cardsIn(track, false);
    var cards = allCards(track);
    if (!reals.length || cards.length < reals.length * 2) return;
    var current = nearestIndex(viewport, cards);
    var count = reals.length;
    if (current < count) jumpTo(viewport, cardLeft(viewport, cards[current + count]));
    else if (current >= count * 2) jumpTo(viewport, cardLeft(viewport, cards[current - count]));
  }

  function go(viewport, track, direction) {
    var reals = cardsIn(track, false);
    var cards = allCards(track);
    if (!reals.length) return;
    var count = reals.length;
    var step = Math.min(perView(viewport, track), count);
    var current = nearestIndex(viewport, cards);

    if (current < count) {
      jumpTo(viewport, cardLeft(viewport, cards[current + count]));
      current += count;
    } else if (current >= count * 2) {
      jumpTo(viewport, cardLeft(viewport, cards[current - count]));
      current -= count;
    }

    var dest = current + direction * step;
    if (dest < count) {
      jumpTo(viewport, cardLeft(viewport, cards[current + count]));
      dest += count;
    } else if (dest >= count * 2) {
      jumpTo(viewport, cardLeft(viewport, cards[current - count]));
      dest -= count;
    }

    viewport.scrollTo({ left: cardLeft(viewport, cards[dest]), behavior: 'smooth' });
  }

  function init(root) {
    if (!root || root.dataset.curlyIngredientsReady === 'true') return;
    var viewport = root.querySelector('[data-curly-ingredients-viewport]');
    var track = root.querySelector('[data-curly-ingredients-track]');
    var prev = root.querySelector('[data-curly-ingredients-prev]');
    var next = root.querySelector('[data-curly-ingredients-next]');
    if (!viewport || !track || !prev || !next) return;
    root.dataset.curlyIngredientsReady = 'true';

    var originals = cardsIn(track, false);
    originals.forEach(function (card) {
      var after = card.cloneNode(true);
      after.setAttribute('data-clone', 'true');
      after.setAttribute('aria-hidden', 'true');
      track.appendChild(after);
    });
    for (var index = originals.length - 1; index >= 0; index -= 1) {
      var before = originals[index].cloneNode(true);
      before.setAttribute('data-clone', 'true');
      before.setAttribute('aria-hidden', 'true');
      track.insertBefore(before, track.firstChild);
    }

    viewport.addEventListener('scrollend', function () {
      var pending = Number(viewport.dataset.curlyIngredientsLock || 0);
      if (pending > 0) {
        viewport.dataset.curlyIngredientsLock = String(pending - 1);
        return;
      }
      recenter(viewport, track);
    });

    prev.addEventListener('click', function () {
      go(viewport, track, -1);
    });
    next.addEventListener('click', function () {
      go(viewport, track, 1);
    });

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        var reals = cardsIn(track, false);
        if (reals[0]) jumpTo(viewport, cardLeft(viewport, reals[0]));
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-curly-ingredients]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-curly-ingredients]');
    if (root) {
      delete root.dataset.curlyIngredientsReady;
      init(root);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-curly-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-curly-review-play]');
  if (!button || button.disabled) return;

  const card = button.closest('[data-curly-review-media]');
  if (!card) return;

  const video = card.querySelector('video');
  const frame = card.querySelector('iframe');

  card.classList.add('is-playing');

  if (video) video.play();

  if (frame) {
    const src = frame.getAttribute('data-src');
    if (src && !frame.getAttribute('src')) frame.setAttribute('src', src);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-editorial-hero-ba"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.lp-editorial-hero-ba__comparison').forEach((comparison) => {
    const beforeTag = comparison.querySelector('.lp-editorial-hero-ba__tag--before');
    const afterTag = comparison.querySelector('.lp-editorial-hero-ba__tag--after');
    if (!beforeTag && !afterTag) return;

    const isVertical = comparison.getAttribute('data-cursor-direction') === 'vertical';
    const hideThreshold = parseFloat(
      getComputedStyle(comparison).getPropertyValue('--lp-editorial-hero-ba-label-hide')
    ) || 7;

    const getCursorPos = () => {
      const inlinePos = comparison.style.getPropertyValue('--image-comparison--cursor-pos').trim();
      const computedPos = getComputedStyle(comparison).getPropertyValue('--image-comparison--cursor-pos').trim();
      return parseFloat(inlinePos || computedPos) || 50;
    };

    const updateLabels = () => {
      const pos = getCursorPos();

      if (beforeTag) {
        const hideBefore = pos <= hideThreshold;
        beforeTag.classList.toggle('is-hidden', hideBefore);
        beforeTag.toggleAttribute('hidden', hideBefore);
      }

      if (afterTag) {
        const hideAfter = pos >= 100 - hideThreshold;
        afterTag.classList.toggle('is-hidden', hideAfter);
        afterTag.toggleAttribute('hidden', hideAfter);
      }
    };

    updateLabels();

    new MutationObserver(updateLabels).observe(comparison, {
      attributes: true,
      attributeFilter: ['style']
    });

    if (!isVertical && afterTag) {
      comparison.addEventListener('transitionend', (event) => {
        if (event.target.classList?.contains('image-comparison--after')) {
          updateLabels();
        }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-editorial-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.lp-editorial-hero__comparison').forEach((comparison) => {
    const beforeTag = comparison.querySelector('.lp-editorial-hero__tag--before');
    const afterTag = comparison.querySelector('.lp-editorial-hero__tag--after');
    if (!beforeTag && !afterTag) return;

    const isVertical = comparison.getAttribute('data-cursor-direction') === 'vertical';
    const hideThreshold = parseFloat(
      getComputedStyle(comparison).getPropertyValue('--lp-editorial-hero-label-hide')
    ) || 7;

    const getCursorPos = () => {
      const inlinePos = comparison.style.getPropertyValue('--image-comparison--cursor-pos').trim();
      const computedPos = getComputedStyle(comparison).getPropertyValue('--image-comparison--cursor-pos').trim();
      return parseFloat(inlinePos || computedPos) || 50;
    };

    const updateLabels = () => {
      const pos = getCursorPos();

      if (beforeTag) {
        const hideBefore = pos <= hideThreshold;
        beforeTag.classList.toggle('is-hidden', hideBefore);
        beforeTag.toggleAttribute('hidden', hideBefore);
      }

      if (afterTag) {
        const hideAfter = pos >= 100 - hideThreshold;
        afterTag.classList.toggle('is-hidden', hideAfter);
        afterTag.toggleAttribute('hidden', hideAfter);
      }
    };

    updateLabels();

    new MutationObserver(updateLabels).observe(comparison, {
      attributes: true,
      attributeFilter: ['style']
    });

    if (!isVertical && afterTag) {
      comparison.addEventListener('transitionend', (event) => {
        if (event.target.classList?.contains('image-comparison--after')) {
          updateLabels();
        }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-heritage-compare"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.lp-heritage-ba__comparison').forEach((comparison) => {
    const beforeTag = comparison.querySelector('.lp-heritage-ba__tag--before');
    const afterTag = comparison.querySelector('.lp-heritage-ba__tag--after');
    if (!beforeTag && !afterTag) return;

    const isVertical = comparison.getAttribute('data-cursor-direction') === 'vertical';
    const hideThreshold = parseFloat(
      getComputedStyle(comparison).getPropertyValue('--lp-heritage-ba-label-hide')
    ) || 7;

    const getCursorPos = () => {
      const inlinePos = comparison.style.getPropertyValue('--image-comparison--cursor-pos').trim();
      const computedPos = getComputedStyle(comparison).getPropertyValue('--image-comparison--cursor-pos').trim();
      return parseFloat(inlinePos || computedPos) || 50;
    };

    const updateLabels = () => {
      const pos = getCursorPos();

      if (beforeTag) {
        const hideBefore = pos <= hideThreshold;
        beforeTag.classList.toggle('is-hidden', hideBefore);
        beforeTag.toggleAttribute('hidden', hideBefore);
      }

      if (afterTag) {
        const hideAfter = pos >= 100 - hideThreshold;
        afterTag.classList.toggle('is-hidden', hideAfter);
        afterTag.toggleAttribute('hidden', hideAfter);
      }
    };

    updateLabels();

    new MutationObserver(updateLabels).observe(comparison, {
      attributes: true,
      attributeFilter: ['style']
    });

    if (!isVertical && afterTag) {
      comparison.addEventListener('transitionend', (event) => {
        if (event.target.classList?.contains('image-comparison--after')) {
          updateLabels();
        }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sj-shopable-reels"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.sj-swiper', {
    resizeObserver: false,
    slidesPerView: 1.2,
    centeredSlides: true,
    spaceBetween: 20,
    grabCursor: true,
    loop: true,
    speed: 500,
    slideToClickedSlide: true,
    freeMode: false,
    freeModeSticky: false,
    resistanceRatio: 0,
    breakpoints: {
      768: { 
        slidesPerView: 3,
        centeredSlides: true,
        spaceBetween: 10,
        freeMode: false,
      },
      1100: { 
        slidesPerView: 4,
        centeredSlides: true,
        spaceBetween: 20,
        freeMode: true,
        freeModeSticky: true,
      },
      1400: { 
        slidesPerView: 5,
        centeredSlides: true,
        spaceBetween: 20,
        freeMode: true,
        freeModeSticky: true,
      }
    },

    on: {
      init:syncVideos,
      slideChangeTransitionEnd: syncVideos
    }
  });

  function syncVideos() {
  document.querySelectorAll('.sj-reels .sj-swiper').forEach(swiper => {
    const isMuted = swiper.classList.contains('is-muted');

    swiper.querySelectorAll('.sj-slide').forEach(slide => {
      const video = slide.querySelector('video');
      if (!video) {
        slide.classList.remove('is-playing');
        slide.classList.add('is-paused');
        return;
      }

      const isActive = slide.classList.contains('swiper-slide-active');

      if (isActive) {
        // Safety: pause first to cancel any pending play()
        video.pause();

        video.muted = isMuted;

        video.play().then(() => {
          // Guard: ensure slide is STILL active
          if (!slide.classList.contains('swiper-slide-active')) {
            video.pause();
            video.currentTime = 0;
          }
        }).catch(() => {});

        slide.classList.add('is-playing');
        slide.classList.remove('is-paused');
      } else {
        // HARD STOP inactive videos
        video.pause();
        video.currentTime = 0;
        video.muted = true;

        slide.classList.remove('is-playing');
        slide.classList.add('is-paused');
      }
    });
  });
}

  // Mute / unmute toggle
  document.querySelectorAll('.sj-sound-control').forEach(btn => {
  btn.addEventListener('click', e => {
    e.stopPropagation();

    // 🔍 scope everything to THIS slider only
    const swiper = btn.closest('.sj-swiper');
    if (!swiper) return;

    const clickedSlide = btn.closest('.sj-slide');
    const clickedVideo = clickedSlide.querySelector('video');
    if (!clickedVideo) return;

    // Flip based on clicked slide's current state
    const newMutedState = !clickedVideo.muted;

    // Apply to ALL videos inside this swiper
    swiper.querySelectorAll('.sj-slide video').forEach(video => {
      video.muted = newMutedState;
    });

    // Update state ONLY on this swiper
    swiper.classList.remove('is-muted', 'is-unmuted');
    swiper.classList.add(newMutedState ? 'is-muted' : 'is-unmuted');
  });
});




});

  } catch(e) { console.error(e); }
})();
})();
